module.exports = __webpack_public_path__ + "static/media/editing_labe_cfd_idro.93573184.png";